/**
 * Dev-only console diagnostics for PropertyList filter / query-driven pagination.
 */

import { IS_DEV } from "@/utils/env";

/**
 * @param {string} message
 */
export const logPropertyFilter = (message) => {
  if (!IS_DEV) return;
  console.log(`[PropertyFilter] ${message}`);
};
